var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1598 0.840504C10.9285 0.608504 10.5532 0.608504 10.3218 0.840504L0.840504 10.3218C0.724504 10.4378 0.666504 10.5892 0.666504 10.7412C0.666504 10.8925 0.724504 11.0445 0.840504 11.1598C1.07184 11.3912 1.4465 11.3912 1.6785 11.1598L11.1598 1.6785C11.3912 1.4465 11.3912 1.07184 11.1598 0.840504ZM8.6667 10.6667C8.11537 10.6667 7.6667 10.218 7.6667 9.6667C7.6667 9.11537 8.11537 8.6667 8.6667 8.6667C9.21804 8.6667 9.6667 9.11537 9.6667 9.6667C9.6667 10.218 9.21804 10.6667 8.6667 10.6667ZM8.6667 7.33337C7.38004 7.33337 6.33337 8.38004 6.33337 9.6667C6.33337 10.9534 7.38004 12 8.6667 12C9.95337 12 11 10.9534 11 9.6667C11 8.38004 9.95337 7.33337 8.6667 7.33337ZM3.33337 2.00004C3.8847 2.00004 4.33337 2.4487 4.33337 3.00004C4.33337 3.55137 3.8847 4.00004 3.33337 4.00004C2.78204 4.00004 2.33337 3.55137 2.33337 3.00004C2.33337 2.4487 2.78204 2.00004 3.33337 2.00004ZM3.33337 5.33337C4.62004 5.33337 5.6667 4.2867 5.6667 3.00004C5.6667 1.71337 4.62004 0.666704 3.33337 0.666704C2.0467 0.666704 1.00004 1.71337 1.00004 3.00004C1.00004 4.2867 2.0467 5.33337 3.33337 5.33337Z",
    fill: "#00A0F3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPercentage);
export default __webpack_public_path__ + "static/media/IconPercentage.988d6a5b.svg";
export { ForwardRef as ReactComponent };